interface MobileMenuProps {
  menuOpen: boolean;
  onClose: () => void;
}

function MobileMenu({ menuOpen, onClose }: MobileMenuProps) {
  if (!menuOpen) return null;

  return (
    <div style={styles.mobileMenu}>
      <a
        style={styles.mobileNavLink}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          onClose();
        }}
      >
        Home
      </a>
      <a
        style={styles.mobileNavLink}
        onClick={() => {
          const section = document.querySelector('[data-persona-section]');
          section?.scrollIntoView({ behavior: 'smooth' });
          onClose();
        }}
      >
        Features
      </a>
      <a
        style={styles.mobileNavLink}
        onClick={() => {
          const section = document.querySelector('[data-download-section]');
          section?.scrollIntoView({ behavior: 'smooth' });
          onClose();
        }}
      >
        Download
      </a>
    </div>
  );
}

export default MobileMenu;

const styles = {
  mobileMenu: {
    position: 'fixed' as const,
    top: '48px',
    left: 0,
    right: 0,
    background: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
    zIndex: 999,
  },

  mobileNavLink: {
    color: '#64748b',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '1.1rem',
    padding: '12px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
  },
};
